import React from 'react';
import './holidayNotice.css';

const HolidayNotice = ({ name }) => (
  <div className="trial-holiday-notice" role="status" aria-live="polite">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="5" width="18" height="16" rx="3" />
      <path d="M16 3v4M8 3v4M3 11h18M9 16h6" />
    </svg>
    <div>
      <strong>{name}</strong>
      <p>No trial sessions on this holiday. Choose another date.</p>
    </div>
  </div>
);

export default HolidayNotice;
